import React from 'react';
import PropTypes from 'prop-types';
import { SuiContainer } from '@splashthat/sui';

const CharacterMaxCount = ({ labelLength, maxLength }) => {
    const hasReachedMax = labelLength >= maxLength;

    return (
        <SuiContainer className={`question-label__char ${hasReachedMax ? 'question-label__char--limit' : ''}`}>
            <p>
                {hasReachedMax ? `${maxLength}/` : 'Max '}
                {maxLength}
            </p>
        </SuiContainer>
    );
};

CharacterMaxCount.propTypes = {
    labelLength: PropTypes.number.isRequired,
    maxLength: PropTypes.number.isRequired,
};

export default CharacterMaxCount;
